import { Column } from "../../../components/TablePaginated/TablePaginated";

export const TableHeaderColumns: Column[] = [
  {
    label: "Número da nota",
    id: "noteNumber",
    align: "left",
  },
  {
    label: "Produto",
    id: "product",
    align: "left",
  },
  {
    label: "Emissão",
    id: "dateOfIssue",
    align: "center",
  },
  {
    label: "Vencimento",
    id: "dueDate",
    align: "center",
  },
  {
    label: "Quantidade",
    id: "quantity",
    align: "right",
  },
  {
    label: "Valor",
    id: "price",
    align: "right",
  },
  {
    label: "Status da nota",
    id: "cancelled",
    align: "center",
  },
  {
    label: "",
    id: "icon",
    align: "center",
  },
];
